import {
	Button,
	Group,
	ListViewGroup,
	ListViewRow,
	Stack,
	Text,
} from '@ekhodealer/ekho-common/rev';

import type { Document, DocumentKey } from '@ekhodealer/ekho-common';

import { DetailedInfoLineItem } from '@common/components/DetailedInfoLineItem';
import Download24 from '@common/components/icons/Download24';
import { InfoLineItem } from '@common/components/InfoLineItem';

import { useDownloadDocument } from '../../api/useDownloadDocument';

interface DocumentWithKey {
	key: DocumentKey;
	document: Document;
}

interface DocumentListProps {
	documents?: DocumentWithKey[];
	orderId?: string;
}

export const DocumentList = ({ documents, orderId }: DocumentListProps) => {
	const { mutate: downloadDocument, isPending, variables } = useDownloadDocument();

	if (!documents || documents.length === 0) {
		return null;
	}

	const handleDownload = (documentKey: DocumentKey) => {
		if (!orderId) {
			return;
		}
		downloadDocument({ documentKey, orderId });
	};

	return (
		<ListViewGroup>
			{documents.map(({ key, document }) => (
				<ListViewRow
					key={key}
					bottomContent={
						<Stack>
							<DetailedInfoLineItem
								primaryLabel={document.label}
								secondaryLabel={document.description}
								rightAccessory={
									<Group itemsSpacing='16' noWrap>
										{document.trackingNumber && (
											<Group.Item>
												<InfoLineItem
													title='Tracking #'
													value={document.trackingNumber}
													isCopyable={true}
												/>
											</Group.Item>
										)}
										{document.isReady ? (
											<Group.Item>
												<Button
													variant='ghost'
													size='icon'
													onPress={() => handleDownload(key)}
													aria-label={`Download ${document.label}`}
													isLoading={
														isPending && variables?.documentKey === key
													}>
													<Download24 />
												</Button>
											</Group.Item>
										) : (
											<Group.Item>
												<Text
													size='footnote'
													weight='regular'
													color='secondary'>
													Not available yet
												</Text>
											</Group.Item>
										)}
									</Group>
								}
							/>
						</Stack>
					}
				/>
			))}
		</ListViewGroup>
	);
};
